<template>
    <v-card outlined class="sod-eod-team-card" :class="{ 'needs-attention': member.is_missing }" @click="$emit('click')">
        <v-card-text class="pb-2">
            <div class="d-flex align-center mb-2" style="gap: 8px;">
                <div class="text-subtitle-2 font-weight-bold text-truncate flex-grow-1">{{ member.name }}</div>
                <v-chip v-for="role in member.roles" :key="role" x-small label
                    :color="roleChipColor(role)" text-color="white">
                    {{ role }}
                </v-chip>
            </div>

            <div class="d-flex mb-2" style="gap: 6px;">
                <v-chip x-small :outlined="member.days_with_sod === 0" :color="member.days_with_sod > 0 ? 'amber darken-2' : 'grey'"
                    :text-color="member.days_with_sod > 0 ? 'white' : undefined">
                    SOD {{ member.days_with_sod }}
                </v-chip>
                <v-chip x-small :outlined="member.days_with_eod === 0" :color="member.days_with_eod > 0 ? 'indigo' : 'grey'"
                    :text-color="member.days_with_eod > 0 ? 'white' : undefined">
                    EOD {{ member.days_with_eod }}
                </v-chip>
                <v-chip v-if="member.most_recent_workload_pulse" x-small :color="pulseColor(member.most_recent_workload_pulse)" text-color="white">
                    {{ pulseLabel(member.most_recent_workload_pulse) }}
                </v-chip>
            </div>

            <div class="text-body-2 mb-1">
                Tasks: <strong>{{ member.completed_count }}/{{ member.planned_count }}</strong>
                <span v-if="member.completion_rate !== null" class="grey--text">
                    ({{ Math.round(member.completion_rate * 100) }}%)
                </span>
            </div>

            <div v-if="member.top_incomplete_reason" class="text-caption grey--text text-truncate">
                Blocker: {{ reasonLabel(member.top_incomplete_reason) }}
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: 'SodEodTeamMemberCard',
    props: {
        member: {
            type: Object,
            required: true,
        },
    },
    methods: {
        roleChipColor(roleName) {
            const key = String(roleName || '').toLowerCase();
            if (key.includes('admin-manager')) return 'deep-purple';
            if (key.includes('admin')) return 'red darken-2';
            if (key.includes('manager')) return 'indigo';
            return 'blue-grey';
        },
        pulseLabel(pulse) {
            return { too_much: 'Too Much', about_right: 'About Right', comfortable: 'Comfortable' }[pulse] || pulse;
        },
        pulseColor(pulse) {
            return { too_much: 'red darken-1', about_right: 'amber darken-2', comfortable: 'green darken-1' }[pulse] || 'grey';
        },
        reasonLabel(reason) {
            const labels = {
                higher_priority: 'Higher priority came up',
                waiting_on_someone: 'Waiting on someone',
                larger_than_expected: 'Larger than expected',
                blocked: 'Blocked',
                other: 'Other',
            };
            return labels[reason] || reason;
        },
    },
};
</script>

<style scoped>
.sod-eod-team-card {
    cursor: pointer;
    transition: box-shadow 0.15s ease;
}

.sod-eod-team-card:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
}

.sod-eod-team-card.needs-attention {
    border-left: 3px solid #d03b3b;
}
</style>
